'use client';
import React from 'react';
import { Section, toSectionProps } from '@bufdir/statistics-pages-components';

type Props = {
  data: any;
};

const PageSectionPreview: React.FC<Props> = ({ data }) => {
  const origin = new URL(process.env.NEXT_PUBLIC_STATS_STRAPI_URL as string)
    .origin;
  const sectionProps = toSectionProps(data, origin);

  return <Section {...sectionProps} />;
};

export default PageSectionPreview;
